
import {gql, MutationHookOptions, useMutation} from '@apollo/client';

const createProvisional = gql`
mutation {
	provisional {
		create {
			id
			token
			error
		}
	}
}`;

interface Result {
	provisional: {
		create: {
			id: string
			token?: string
			error?: string
		}
	}
}

export const useCreateProvisional = (
	options?: MutationHookOptions<Result>,
) => {
	return useMutation<Result>(
		createProvisional, {
			// CreateProvisional requires a call to Stripe to create
			// a customer on their servers; this is a slow-sometimes query
			context: {
				slowQuery: true,
			},
			...options,
		},
	);
};
